import React from 'react'
import { connect } from 'react-redux'
import styles from './Pocs.module.css';
import { getDateMDYY, getPocText, getStatusIndicator } from '_helpers';

class PatientHomeAdmissionPocs extends React.Component {

    render() {
        if (Object.keys(this.props.pocs).length > 0) {

            let firstPoc = this.props.pocs[Object.keys(this.props.pocs)[0]].id;
            return (
                <div>
                    <div className={styles.poc_header}>Plans of Care</div>
                    {Object.keys(this.props.pocs)
                        .map(id => {
                            const poc = this.props.pocs[id];
                            if (poc.id === firstPoc) {
                                return (
                                    <div className={styles.poc_wrapper} key={poc.id}>
                                        <span className={styles.indicator}>{getStatusIndicator(poc.status)}</span>
                                        <span className={styles.date_range}>{getDateMDYY(poc.startDate) + ' - ' + getDateMDYY(poc.endDate)}</span>
                                        <span className={styles.poc}>{getPocText(poc)}</span>
                                        <span className={styles.remaining}>{'(' + (poc.pocVisits - poc.actualVisits) + ' visits remaining)'}</span>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className={styles.poc_wrapper} key={poc.id}>
                                        <span className={styles.indicator}></span>
                                        <span className={styles.date_range}>{getDateMDYY(poc.startDate) + ' - ' + getDateMDYY(poc.endDate)}</span>
                                        <span className={styles.poc}>{getPocText(poc)}</span>
                                        <span className={styles.remaining}></span>
                                    </div>
                                )
                            }
                        })
                    }

                </div>
            );
        } else {
            return (
                <div>
                    <div className={styles.poc_header}>Plans of Care</div>
                    <div className={styles.no_poc}>
                        <i>No Plans of Care</i>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownprops) {
    return {
        pocs: Object.keys(state.entities.pocs)
            .filter(key => { return state.entities.pocs[key].epno === ownprops.epno })
            .sort((a, b) => new Date(state.entities.pocs[b].startDate).getTime() - new Date(state.entities.pocs[a].startDate).getTime())
            .map(key => state.entities.pocs[key]),
    };
}

const connectedPatientHomeAdmissionPocs = connect(mapStateToProps)(PatientHomeAdmissionPocs);
export { connectedPatientHomeAdmissionPocs as PatientHomeAdmissionPocs };

